<template>
  <div>
    <b-button size="sm" class="ml-2" @click="openModal()">
      {{ $t("story.button") }}
    </b-button>

    <b-modal
      ref="openModal"
      class="historyChange"
      scrollable
      size="xl"
      :title="$t('story.title')"
    >
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="filterFields"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :empty-filtered-text="$t('table.noRecord')"
        show-empty
        striped
        hover
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <div v-if="filterFields[field.filterKey] != null">
                <b-form-input
                  v-if="field.key == 'date'"
                  type="date"
                  v-model="filterFields[field.filterKey]"
                />
                <b-form-input
                  v-else
                  v-model="filterFields[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
      <template #modal-footer="{ ok }">
        <div class="w-100 d-flex justify-content-end">
          <b-button class="float-right" variant="danger" @click="ok()">
            {{ $t("geral.close") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Audit",
  props: {
    table: String,
    keyValue: String,
  },
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "changedColumn",
          filterKey: "changedColumn",
          label: this.$t("story.changedColumn"),
        },
        {
          key: "oldValue",
          filterKey: "oldValue",
          label: this.$t("story.oldValue"),
        },
        {
          key: "newValue",
          filterKey: "newValue",
          label: this.$t("story.newValue"),
        },
        {
          key: "date",
          filterKey: "date",
          label: this.$t("story.date"),
          thStyle: "min-width: 160px",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
        },
        {
          key: "userDisplayName",
          filterKey: "userDisplayName",
          label: this.$t("story.userDisplayName"),
          thStyle: "min-width: 250px",
        },
      ],
      filterFields: {
        date: "",
        changedColumn: "",
        oldValue: "",
        newValue: "",
        userDisplayName: "",
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      /*
            string changedColumn = null,
            string oldValue = null,
            string newValue = null,
            DateTime? date = null,
            string userDisplayName = null
      */
      this.$apiScheduler
        .get(
          `/v1/audit/${this.table}/${this.keyValue}?currentPage=${ctx.currentPage}&perPage=${ctx.perPage}&changedColumn=${ctx.filter.changedColumn}&oldValue=${ctx.filter.oldValue}&newValue=${ctx.filter.newValue}&date=${ctx.filter.date}&userDisplayName=${ctx.filter.userDisplayName}`
        )
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>
  